import {ModuleController} from "../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../infrastructure/domain-services/base-managed-service";
import {ScoreboardWidgetConfig} from "./scoreboard-widget.config";
import {ScoreboardWidgetStore} from "./scoreboard-widget.store";
import {ScoreboardWidgetHandlers} from "./handlers/scoreboard-widget.handlers";

export class ScoreboardWidgetController extends ModuleController {
  static injectables = [...BaseManagedService.injectables, ScoreboardWidgetConfig, ScoreboardWidgetStore, ScoreboardWidgetHandlers];

}
